import { CarrouselContainer, TextWrapper } from "../carrousel/styles";
import { withImageFallback } from "../../utils/imageFallback";

interface CarrosselPreviewProps {
  titulo?: string;
  texto?: string;
  imagem?: string;
}

export const CarrosselPreview = ({
  titulo = "",
  texto = "",
  imagem = "",
}: CarrosselPreviewProps) => {
  return (
    <CarrouselContainer>
      <TextWrapper>
        <h2>{titulo || "Título do carrossel"}</h2>
        <h3>{texto || "Texto de pré-visualização do carrossel."}</h3>
      </TextWrapper>
      <img
        src={withImageFallback(imagem)}
        alt={titulo || "Pré-visualização do carrossel"}
      />
    </CarrouselContainer>
  );
};
